import React, { useState, useEffect } from "react";
import { Tabs, Tab, Typography, Box, Grid, CardContent, Stack } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import commonMessages from "../../utility/constant";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import axios from "axios";
import { getAuthToken } from "../../utility/tokenUtility";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";

const WorkOrderByCategory = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [WOtotalScheduledPPMCount, setWOtotalScheduledPPMCount] = useState(0);
  const [WOtotalScheduledPredictiveMaintenanceCount, setWOtotalScheduledPredictiveMaintenanceCount] = useState(0);
  const [WOtotalScheduledCorrectiveMaintenanceCount, setWOtotalScheduledCorrectiveMaintenanceCount] = useState(0);
  const [WOtotalUnScheduledBreadkdownCount, setWOtotalUnScheduledBreadkdownCount] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

   const allMonths = commonMessages.months; // Assuming `commonMessages.months` is an array of month names.
    const all = { label: "All", value: "All", id: "0" };
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth();

    const [year, setYear] = useState(() => {
        const initialYear =  currentYear.toString();
        return { label: initialYear, value: initialYear };
    });

    const [month, setMonth] = useState(() => {
        const initialMonth =
            allMonths[currentMonthIndex]; // Default to current month if not in location.state            
        return initialMonth;
    });

    const [monthsOptions, setMonthsOptions] = useState([]);
    const [yearsOptions, setYearsOptions] = useState([]);

    const fetchMaintenanceYears = async () => {
        const facilityid = localStorage.getItem("facilityId");
        try {
            const maintenanceYearResponse = await axios.get(
                `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`
            );
            const years = maintenanceYearResponse.data.items.map(year => ({
                label: year.maintyearvalue.toString(),
                value: year.maintyearvalue.toString(),
            }));
            setYearsOptions(years || []);
        } catch (error) {
            console.error('Error fetching maintenance years:', error);
        }
    };

    useEffect(() => {
        const selectedYear = parseInt(year.value);
        const isNextYear = currentMonthIndex === 11;

        const months =
            selectedYear === currentYear
                ? [
                    all,
                    ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                    // ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                ]
                : [all, ...allMonths]; // All months for previous years

        setMonthsOptions(months);

        // if (!location?.state?.month) {

            setMonth(
                selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
            );
        // }
    }, [year]);



  const fetchtotalCount = async () => {
          try {
            const facilityid = localStorage.getItem("facilityId");
              const token = getAuthToken("id_token");
              const config = {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
              };

              // Define the API endpoints
              const apiUrlFEMS = `${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountByFacilityIdWOCategoryCount/${facilityid}/${month?.id}/${year?.value}`;
              const apiUrlBEMS = `${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountByFacilityIdWOCategoryCount/${facilityid}/${month?.id}/${year?.value}`;
  
              // Fetch data from both endpoints simultaneously
              const [responseFEMS, responseBEMS] = await Promise.all([
                  axios.get(apiUrlFEMS, config),
                  axios.get(apiUrlBEMS, config),
              ]);
  
              // Extract counts from both responses
              const femsCounts = responseFEMS.data || 0;
              const bemsCounts = responseBEMS.data || 0;
  
            
              const WOtotalScheduledPPMCount1 = (femsCounts.totalScheduledPPMCount || 0) + (bemsCounts.totalScheduledPPMCount || 0);
              const WOtotalScheduledPredictiveMaintenanceCount1 = (femsCounts.totalScheduledPredictiveMaintenanceCount || 0) + (bemsCounts.totalScheduledPredictiveMaintenanceCount || 0);
              const WOtotalScheduledCorrectiveMaintenanceCount1 = (femsCounts.totalScheduledCorrectiveMaintenanceCount || 0) + (bemsCounts.totalScheduledCorrectiveMaintenanceCount || 0);
              const WOtotalUnScheduledBreadkdownCount1 = (femsCounts.totalUnScheduledBreadkdownCount || 0) + (bemsCounts.totalUnScheduledBreadkdownCount || 0);
  
              
          setWOtotalScheduledPPMCount(WOtotalScheduledPPMCount1);
          setWOtotalScheduledPredictiveMaintenanceCount(WOtotalScheduledPredictiveMaintenanceCount1);
          setWOtotalScheduledCorrectiveMaintenanceCount(WOtotalScheduledCorrectiveMaintenanceCount1);
          setWOtotalUnScheduledBreadkdownCount(WOtotalUnScheduledBreadkdownCount1);
  
          } catch (error) {
              //  console.error("Error fetching data", error);
          }
      };


            useEffect(() => {
      if (year && month) {

        fetchMaintenanceYears();
        fetchtotalCount();
      }
    }, [year, month]);

  // Dynamically change data based on the selected tab
  const data =
    selectedTab === 0
      ? [
        {
          id: "Scheduled PPM",
          value: WOtotalScheduledPPMCount,
          color: "#4CAF50",
        },
        {
          id: "Scheduled Predictive Maintenance",
          value: WOtotalScheduledPredictiveMaintenanceCount,
          color: "#FF9800",
        },
        {
          id: "Scheduled Corrective Maintenance",
          value: WOtotalScheduledCorrectiveMaintenanceCount,
          color: "#9E9E9E",
        },
      ]
      : [
        {
          id: "Breakdown",
          value: WOtotalUnScheduledBreadkdownCount,
          color: "#4CAF50",
        },
      ];

 
  
   

    const handleYearChange = (newValue) => {
        if (newValue && newValue.value !== year?.value) {
            const selectedYear = parseInt(newValue.value);
            const currentDate = new Date();
            const currentMonthIndex = currentDate.getMonth();

            const months =
                selectedYear === currentYear
                    ? [
                        all,
                        ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
                        ...(currentMonthIndex === 11 ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
                    ]
                    : [all, ...allMonths]; // All months for previous years

            setYear(newValue); // Keep the selected year
            setMonthsOptions(months);
            setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]); // Default to the start of the year for future years
        }
    };

    const handleMonthChange = (newValue) => {
        setMonth(newValue);
    };



  return (
    <StyledCard>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Typography variant="h5" fontWeight={700} color="text.primary">
            W.O. By Category
          </Typography>

          <Stack direction="row" alignItems="center" gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder="Select Year"
              disableClearable
              highlight
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder="Select Month"
              disableClearable
              disabled={!year}
              highlight
            />
          </Stack>
        </Stack>



        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="WO by Category"

        >
          <Tab label="Scheduled" />
          <Tab label="Unscheduled" />


        </Tabs>


        {/* Content for the selected tab */}
        <Box>
          {/* Pie Chart with Increased Space */}
          <Box>
            <PieChart
             onItemClick={(event, d) => navigate("/workorder", { state: { year: year?.value,  month: { value: month?.value, label: month?.label, id: month?.id }} } )}
              series={[
                {
                  data: data.map((item) => ({
                    id: item.id,
                    label: item.id,
                    value: item.value,
                    color: item.color, // Add the color inside the data
                  })),
                  innerRadius: 50, // Thicker ring
                  outerRadius: 90,
                },
              ]}
              height={200}
              margin={{ left: 100 }} // Increased left margin
              slotProps={{ legend: { hidden: true } }}
            />
          </Box>

          {/* Legend and Values */}
          <Box>
            <Grid container direction="column" alignContent="center">
              {data.map((item) => (
                <Grid
                  item
                  key={item.id}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {/* Corrected Color indicator */}
                  <Box
                    sx={{
                      minWidth: 16,
                      minHeight: 16,
                      backgroundColor: item.color,
                      borderRadius: "50%", // Ensures the shape is round
                      marginRight: 1,
                    }}
                  />
                  {/* Label and value */}
                  <Typography
                    variant="body1"
                    sx={{ textWrap: "nowrap", marginRight: "10px" }}
                  >
                    {item.id}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      marginLeft: "auto",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 0,
                    }}
                  >
                    {item.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default WorkOrderByCategory;
